import "./lit-element-CwWchyls.js";
import { L as wt } from "./lds-element-BuoW29Nx.js";
(function() {
  (function(v) {
    const o = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), it = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), E = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, rt = (e, t) => {
      for (let a in E) {
        t[a] = null;
        let i = null;
        const r = E[a];
        Object.defineProperty(t, a, {
          get() {
            return i;
          },
          set(s) {
            i = s, e.isConnected ? e.setAttribute(r, s) : b.set(e, t);
          }
        });
      }
    };
    function U(e) {
      const t = c.get(e), { form: a } = t;
      j(e, a, t), B(e, t.labels);
    }
    const $ = (e, t = !1) => {
      const a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode(s) {
          return c.has(s) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let i = a.nextNode();
      const r = !t || e.disabled;
      for (; i; )
        i.formDisabledCallback && r && S(i, e.disabled), i = a.nextNode();
    }, z = { attributes: !0, attributeFilter: ["disabled", "name"] }, M = V() ? new MutationObserver((e) => {
      for (const t of e) {
        const a = t.target;
        if (t.attributeName === "disabled" && (a.constructor.formAssociated ? S(a, a.hasAttribute("disabled")) : a.localName === "fieldset" && $(a)), t.attributeName === "name" && a.constructor.formAssociated) {
          const i = c.get(a), r = R.get(a);
          i.setFormValue(r);
        }
      }
    }) : {};
    function k(e) {
      e.forEach((t) => {
        const { addedNodes: a, removedNodes: i } = t, r = Array.from(a), s = Array.from(i);
        r.forEach((n) => {
          var u;
          if (c.has(n) && n.constructor.formAssociated && U(n), b.has(n)) {
            const l = b.get(n);
            Object.keys(E).filter((m) => l[m] !== null).forEach((m) => {
              n.setAttribute(E[m], l[m]);
            }), b.delete(n);
          }
          if (w.has(n)) {
            const l = w.get(n);
            n.setAttribute("internals-valid", l.validity.valid.toString()), n.setAttribute("internals-invalid", (!l.validity.valid).toString()), n.setAttribute("aria-invalid", (!l.validity.valid).toString()), w.delete(n);
          }
          if (n.localName === "form") {
            const l = y.get(n), p = document.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, {
              acceptNode(N) {
                return c.has(N) && N.constructor.formAssociated && !(l && l.has(N)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let m = p.nextNode();
            for (; m; )
              U(m), m = p.nextNode();
          }
          n.localName === "fieldset" && ((u = M.observe) === null || u === void 0 || u.call(M, n, z), $(n, !0));
        }), s.forEach((n) => {
          const u = c.get(n);
          u && h.get(u) && q(u), A.has(n) && A.get(n).disconnect();
        });
      });
    }
    function st(e) {
      e.forEach((t) => {
        const { removedNodes: a } = t;
        a.forEach((i) => {
          const r = _.get(t.target);
          c.has(i) && J(i), r.disconnect();
        });
      });
    }
    const nt = (e) => {
      var t, a;
      const i = new MutationObserver(st);
      !((t = window == null ? void 0 : window.ShadyDOM) === null || t === void 0) && t.inUse && e.mode && e.host && (e = e.host), (a = i.observe) === null || a === void 0 || a.call(i, e, { childList: !0 }), _.set(e, i);
    };
    V() && new MutationObserver(k);
    const I = {
      childList: !0,
      subtree: !0
    }, S = (e, t) => {
      e.toggleAttribute("internals-disabled", t), t ? e.setAttribute("aria-disabled", "true") : e.removeAttribute("aria-disabled"), e.formDisabledCallback && e.formDisabledCallback.apply(e, [t]);
    }, q = (e) => {
      h.get(e).forEach((a) => {
        a.remove();
      }), h.set(e, []);
    }, K = (e, t) => {
      const a = document.createElement("input");
      return a.type = "hidden", a.name = e.getAttribute("name"), e.after(a), h.get(t).push(a), a;
    }, ot = (e, t) => {
      var a;
      h.set(t, []), (a = M.observe) === null || a === void 0 || a.call(M, e, z);
    }, B = (e, t) => {
      if (t.length) {
        Array.from(t).forEach((i) => i.addEventListener("click", e.click.bind(e)));
        let a = t[0].id;
        t[0].id || (a = "".concat(t[0].htmlFor, "_Label"), t[0].id = a), e.setAttribute("aria-labelledby", a);
      }
    }, C = (e) => {
      const t = Array.from(e.elements).filter((s) => !s.tagName.includes("-") && s.validity).map((s) => s.validity.valid), a = y.get(e) || [], i = Array.from(a).filter((s) => s.isConnected).map((s) => c.get(s).validity.valid), r = [...t, ...i].includes(!1);
      e.toggleAttribute("internals-invalid", r), e.toggleAttribute("internals-valid", !r);
    }, lt = (e) => {
      C(F(e.target));
    }, ct = (e) => {
      C(F(e.target));
    }, dt = (e) => {
      const t = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((a) => "".concat(a, ":not([disabled])")).map((a) => "".concat(a, ":not([form])").concat(e.id ? ",".concat(a, "[form='").concat(e.id, "']") : "")).join(",");
      e.addEventListener("click", (a) => {
        if (a.target.closest(t)) {
          const r = y.get(e);
          if (e.noValidate)
            return;
          r.size && Array.from(r).reverse().map((u) => c.get(u).reportValidity()).includes(!1) && a.preventDefault();
        }
      });
    }, ut = (e) => {
      const t = y.get(e.target);
      t && t.size && t.forEach((a) => {
        a.constructor.formAssociated && a.formResetCallback && a.formResetCallback.apply(a);
      });
    }, j = (e, t, a) => {
      if (t) {
        const i = y.get(t);
        if (i)
          i.add(e);
        else {
          const r = /* @__PURE__ */ new Set();
          r.add(e), y.set(t, r), dt(t), t.addEventListener("reset", ut), t.addEventListener("input", lt), t.addEventListener("change", ct);
        }
        it.set(t, { ref: e, internals: a }), e.constructor.formAssociated && e.formAssociatedCallback && setTimeout(() => {
          e.formAssociatedCallback.apply(e, [t]);
        }, 0), C(t);
      }
    }, F = (e) => {
      let t = e.parentNode;
      return t && t.tagName !== "FORM" && (t = F(t)), t;
    }, f = (e, t, a = DOMException) => {
      if (!e.constructor.formAssociated)
        throw new a(t);
    }, G = (e, t, a) => {
      const i = y.get(e);
      return i && i.size && i.forEach((r) => {
        c.get(r)[a]() || (t = !1);
      }), t;
    }, J = (e) => {
      if (e.constructor.formAssociated) {
        const t = c.get(e), { labels: a, form: i } = t;
        B(e, a), j(e, i, t);
      }
    };
    function V() {
      return typeof MutationObserver < "u";
    }
    class ht {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const mt = (e) => (e.badInput = !1, e.customError = !1, e.patternMismatch = !1, e.rangeOverflow = !1, e.rangeUnderflow = !1, e.stepMismatch = !1, e.tooLong = !1, e.tooShort = !1, e.typeMismatch = !1, e.valid = !0, e.valueMissing = !1, e), ft = (e, t, a) => (e.valid = pt(t), Object.keys(t).forEach((i) => e[i] = t[i]), a && C(a), e), pt = (e) => {
      let t = !0;
      for (let a in e)
        a !== "valid" && e[a] !== !1 && (t = !1);
      return t;
    }, T = /* @__PURE__ */ new WeakMap();
    function Q(e, t) {
      e.toggleAttribute(t, !0), e.part && e.part.add(t);
    }
    class L extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (super(), !t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        T.set(this, t);
      }
      add(t) {
        if (!/^--/.test(t) || typeof t != "string")
          throw new DOMException("Failed to execute 'add' on 'CustomStateSet': The specified value ".concat(t, " must start with '--'."));
        const a = super.add(t), i = T.get(this), r = "state".concat(t);
        return i.isConnected ? Q(i, r) : setTimeout(() => {
          Q(i, r);
        }), a;
      }
      clear() {
        for (let [t] of this.entries())
          this.delete(t);
        super.clear();
      }
      delete(t) {
        const a = super.delete(t), i = T.get(this);
        return i.isConnected ? (i.toggleAttribute("state".concat(t), !1), i.part && i.part.remove("state".concat(t))) : setTimeout(() => {
          i.toggleAttribute("state".concat(t), !1), i.part && i.part.remove("state".concat(t));
        }), a;
      }
    }
    function X(e, t, a, i) {
      if (a === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
      if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return a === "m" ? i : a === "a" ? i.call(e) : i ? i.value : t.get(e);
    }
    function yt(e, t, a, i, r) {
      if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return t.set(e, a), a;
    }
    var g;
    class gt {
      constructor(t) {
        g.set(this, void 0), yt(this, g, t);
        for (let a = 0; a < t.length; a++) {
          let i = t[a];
          this[a] = i, i.hasAttribute("name") && (this[i.getAttribute("name")] = i);
        }
        Object.freeze(this);
      }
      get length() {
        return X(this, g, "f").length;
      }
      [(g = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return X(this, g, "f")[Symbol.iterator]();
      }
      item(t) {
        return this[t] == null ? null : this[t];
      }
      namedItem(t) {
        return this[t] == null ? null : this[t];
      }
    }
    function vt() {
      const e = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = a;
      const t = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = i;
      function a(...s) {
        let n = e.apply(this, s);
        return G(this, n, "checkValidity");
      }
      function i(...s) {
        let n = t.apply(this, s);
        return G(this, n, "reportValidity");
      }
      const { get: r } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...s) {
          const n = r.call(this, ...s), u = Array.from(y.get(this) || []);
          if (u.length === 0)
            return n;
          const l = Array.from(n).concat(u).sort((p, m) => p.compareDocumentPosition ? p.compareDocumentPosition(m) & 2 ? 1 : -1 : 0);
          return new gt(l);
        }
      });
    }
    class Y {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (!t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const a = t.getRootNode(), i = new ht();
        this.states = new L(t), o.set(this, t), d.set(this, i), c.set(t, this), rt(t, this), ot(t, this), Object.seal(this), a instanceof DocumentFragment && nt(a);
      }
      checkValidity() {
        const t = o.get(this);
        if (f(t, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const a = d.get(this);
        if (!a.valid) {
          const i = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          t.dispatchEvent(i);
        }
        return a.valid;
      }
      get form() {
        const t = o.get(this);
        f(t, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let a;
        return t.constructor.formAssociated === !0 && (a = F(t)), a;
      }
      get labels() {
        const t = o.get(this);
        f(t, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const a = t.getAttribute("id"), i = t.getRootNode();
        return i && a ? i.querySelectorAll('[for="'.concat(a, '"]')) : [];
      }
      reportValidity() {
        const t = o.get(this);
        if (f(t, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const a = this.checkValidity(), i = D.get(this);
        if (i && !t.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !a && i && (t.focus(), i.focus()), a;
      }
      setFormValue(t) {
        const a = o.get(this);
        if (f(a, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), q(this), t != null && !(t instanceof FormData)) {
          if (a.getAttribute("name")) {
            const i = K(a, this);
            i.value = t;
          }
        } else t != null && t instanceof FormData && Array.from(t).reverse().forEach(([i, r]) => {
          if (typeof r == "string") {
            const s = K(a, this);
            s.name = i, s.value = r;
          }
        });
        R.set(a, t);
      }
      setValidity(t, a, i) {
        const r = o.get(this);
        if (f(r, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !t)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        D.set(this, i);
        const s = d.get(this), n = {};
        for (const p in t)
          n[p] = t[p];
        Object.keys(n).length === 0 && mt(s);
        const u = Object.assign(Object.assign({}, s), n);
        delete u.valid;
        const { valid: l } = ft(s, u, this.form);
        if (!l && !a)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        P.set(this, l ? "" : a), r.isConnected ? (r.toggleAttribute("internals-invalid", !l), r.toggleAttribute("internals-valid", l), r.setAttribute("aria-invalid", "".concat(!l))) : w.set(r, this);
      }
      get shadowRoot() {
        const t = o.get(this), a = H.get(t);
        return a || null;
      }
      get validationMessage() {
        const t = o.get(this);
        return f(t, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), P.get(this);
      }
      get validity() {
        const t = o.get(this);
        return f(t, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), d.get(this);
      }
      get willValidate() {
        const t = o.get(this);
        return f(t, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(t.disabled || t.hasAttribute("disabled") || t.hasAttribute("readonly"));
      }
    }
    function bt() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class e extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const t = "element-internals-feature-detection-".concat(Math.random().toString(36).replace(/[^a-z]+/g, ""));
      customElements.define(t, e);
      const a = new e();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((i) => i in a.internals);
    }
    let Z = !1, tt = !1;
    function x(e) {
      tt || (tt = !0, window.CustomStateSet = L, e && (HTMLElement.prototype.attachInternals = function(...t) {
        const a = e.call(this, t);
        return a.states = new L(this), a;
      }));
    }
    function et(e = !0) {
      if (!Z) {
        if (Z = !0, typeof window < "u" && (window.ElementInternals = Y), typeof CustomElementRegistry < "u") {
          const t = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(a, i, r) {
            if (i.formAssociated) {
              const s = i.prototype.connectedCallback;
              i.prototype.connectedCallback = function() {
                W.has(this) || (W.set(this, !0), this.hasAttribute("disabled") && S(this, !0)), s != null && s.apply(this), J(this);
              };
            }
            t.call(this, a, i, r);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (c.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new Y(this);
        }), typeof Element < "u") {
          let t = function(...i) {
            const r = a.apply(this, i);
            if (H.set(this, r), V()) {
              const s = new MutationObserver(k);
              window.ShadyDOM ? s.observe(this, I) : s.observe(r, I), A.set(this, s);
            }
            return r;
          };
          const a = Element.prototype.attachShadow;
          Element.prototype.attachShadow = t;
        }
        V() && typeof document < "u" && new MutationObserver(k).observe(document.documentElement, I), typeof HTMLFormElement < "u" && vt(), (e || typeof window < "u" && !window.CustomStateSet) && x();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (bt() ? typeof window < "u" && !window.CustomStateSet && x(HTMLElement.prototype.attachInternals) : et(!1)), v.forceCustomStateSetPolyfill = x, v.forceElementInternalsPolyfill = et, Object.defineProperty(v, "__esModule", { value: !0 }), v;
  })({});
})();
const O = class O extends wt {
  constructor() {
    super(), this._errors = [], this.value = "", this.hasError = !1, this.validators = [], this.currentValidationErrors = [], this.ranFirstUpdatedCycle = !1, this.internals = this.attachInternals(), this.addEventListener("invalid", () => {
      this.validateAndUpdateForm();
    });
  }
  set errors(o) {
    this._errors = o, this.validateAndUpdateForm(), this.requestUpdate();
  }
  get errors() {
    return this._errors || [];
  }
  get validity() {
    var o;
    return (o = this.validationElement) == null ? void 0 : o.validity;
  }
  get validationMessage() {
    var o;
    return (o = this.validationElement) == null ? void 0 : o.validationMessage;
  }
  get formValue() {
    return this.value;
  }
  getValidationState() {
    var o, d;
    return ((o = this.validity) == null ? void 0 : o.valid) && this.validators.map((h) => h(this)) && !((d = this.errors) != null && d.length);
  }
  checkValidity() {
    return this.validationElement ? this.validationElement.checkValidity() : !0;
  }
  reportValidity() {
    var o;
    return (o = this.validationElement) == null ? void 0 : o.reportValidity();
  }
  setCustomValidity(o) {
    var d;
    (d = this.validationElement) == null || d.setCustomValidity(o);
  }
  updated(o) {
    if (!this.ranFirstUpdatedCycle) {
      this.ranFirstUpdatedCycle = !0;
      return;
    }
    o.has("value") && this.validateAndUpdateForm();
  }
  beforeFormUpdate() {
  }
  validateAndUpdateForm() {
    var d, h;
    const o = (d = this.validators) == null ? void 0 : d.map((c) => c(this));
    this.currentValidationErrors = o.filter((c) => c !== !0), ((h = this._errors) == null ? void 0 : h.length) > 0 ? this.setCustomValidity(this._errors[0]) : this.currentValidationErrors.length > 0 ? this.setCustomValidity(this.currentValidationErrors[0]) : this.setCustomValidity(""), this.beforeFormUpdate(), this.updateForm(), this.hasAttribute("has-error") || (this.hasError = !this.checkValidity(), this.requestUpdate());
  }
  firstUpdated() {
    this.setAttribute("form-element", ""), this.updateForm();
  }
  updateForm() {
    var o, d;
    this.validationElement && (this.dispatchEvent(new CustomEvent("form-element-value-changed", { bubbles: !0 })), (o = this.internals) == null || o.setFormValue(this.formValue), (d = this.internals) == null || d.setValidity(this.validity, this.validationMessage, this.validationElement));
  }
};
O.formAssociated = !0;
let at = O;
export {
  at as L
};
